import React, {Component} from 'react';
import {Button, Form, Grid, Header,Segment,Message, Icon, Table,Input, Image,Popup} from "semantic-ui-react";
import { CUSTOMER_SERVICE_API_URL,REPORT_ACTIONS_API_URL } from '../../constants/api_routes';
import {getReportById} from "../../data/report_api";
import { DropzoneComponent } from 'react-dropzone-component';
import {createCustomerServiceQuery,notifyUser,uploadCustomerServiceQueryImages} from "../../data/dashboard_api";
import {CollapsiblePanel, Toggle} from '../universal/collapsiblePanel';
import 'react-day-picker/lib/style.css';
import 'rc-time-picker/assets/index.css';
import CreateAgentUser from "../user/agent/create_user";
import Loader from "../universal/loader";
import AssignClerk from "./assign_clerk";
import AddCustomerServiceItem from './add_customer_service_item';
import { getReportByIDReportViewer } from '../../data/report_viewer_api';

class AddCustomerService extends Component {

    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            itemAttachments:[],
            queryType: "comment",
            isCreating: false,
            loaderText:"Uploading Query",
            imageError:false,
            reportData:undefined,
            loading:true,
            expanded:true,
            lastItemIndex:0,
            acknowledgeString:"",
            failedUploadsGeneral:[],
            failedUploadsItems:[],
            isFinishing:false,
            queryComment:""
        };
    }

    componentDidMount() {
        if(this.props.token){
            getReportByIDReportViewer( this.props.reportId,this.props.token).then(response =>{this.sortItemData(response)}) 
        }
        else{   
            getReportById(REPORT_ACTIONS_API_URL, this.props.reportId).then(response =>{this.sortItemData(response)})
        }
    }
    
    toggleExpand = (e) =>{
        e.preventDefault()
        this.setState({expanded:!this.state.expanded})
    }
    
    toggleList = (e,roomIndex,groupIndex,itemIndex) => {
    e.preventDefault();
    let newReportData = {...this.state.reportData}
    newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].selected = !newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].selected   
    if (!newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].selected ) {
        newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].images=[]
    }
    this.setState({reportData:newReportData})
    }
    
    updateComment = (e,roomIndex,groupIndex,itemIndex) => {

        e.preventDefault();
        let newReportData = {...this.state.reportData}
        newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].comment = e.target.value
        this.setState({reportData:newReportData})
    }
    
    addItemImage = (file,roomIndex,groupIndex,itemIndex) =>{
        let newReportData = {...this.state.reportData}
        newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].images.push(file)
        this.setState({reportData:newReportData})
    
    }
    removeItemImage = (file,roomIndex,groupIndex,itemIndex) =>{
        let newReportData = {...this.state.reportData}
        if(newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].images.indexOf(file) !== -1){
            newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].images.splice(newReportData.rooms[roomIndex].groups[groupIndex].items[itemIndex].images.indexOf(file),1)   
        }
        
        this.setState({reportData:newReportData})
    }
    sortItemData = (reportData) => {
        let itemIndex = 1
        reportData["report"] && reportData["report"]["rooms"] && reportData["report"]["rooms"].map((room) =>{
            room.groups.map((group)=>{group.items.map((item)=>{item.group = group.name; item.room = room.name;item.itemIndex = itemIndex;item.selected = false;item.images =[];item.comment = ""; itemIndex++})})
        }
        )
        this.setState({reportData:reportData["report"],loading:false,lastItemIndex:itemIndex})
    }
    
    downloadProgress = () =>{

        let newReportData = JSON.parse(JSON.stringify(this.state.reportData));

        newReportData.rooms.forEach(room => {
        room.groups.forEach(group => {
            group.items.forEach(item => {
                item.images = []
            });
        });
        });

        let jsonOutput = JSON.stringify({reportData:newReportData,queryComment:this.state.queryComment});
        const blob = new Blob([jsonOutput], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        
        const a = document.createElement("a");
        a.href = url;
        a.download = "form-progress.json";
        a.click();
        URL.revokeObjectURL(url);
    }

    importProgress = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
        try {
        const importedState = JSON.parse(e.target.result);
        this.setState({ reportData: importedState.reportData,queryComment:importedState.queryComment }); // adjust key as needed
        } catch (err) {
        console.error("Invalid JSON file", err);
        }
    };
    reader.readAsText(file);
    };

    sortItemDataForSubmit = () =>{
        let itemAttachments = []
        let itemsToSubmit = []
        let newReportData = {...this.state.reportData}
        newReportData.rooms.map(room =>{
         room.groups.map((group =>{
            group.items.map(item =>{
                    if (item.selected){
                        let newItem = JSON.parse(JSON.stringify(item)) 
                       for (let i = 0; i < item.images.length; i++){
                        itemAttachments.push(item.images[i])
                        newItem.images[i] = item.images[i].upload.uuid
                       }
                       itemsToSubmit.push(newItem)
                    }
                    
                })}))
        })
        
        return [itemsToSubmit, itemAttachments]
       }
    handleSubmit = async (e) => {
        e.preventDefault();
        try {
        const formData = new FormData(e.target);
        formData.append("inspection_id", this.props.inspectionId);
        formData.append("query_type", this.state.queryType);
        formData.append("token", this.props.token)
        let itemData = this.sortItemDataForSubmit()
        this.setState({isCreating:true,loaderText:"Creating Query..."});
        let attachmentArr = []
        this.state.attachments.map((att) =>{attachmentArr.push(att.upload.uuid)})
        formData.append("general_images",JSON.stringify(attachmentArr))
        formData.append("query_items", JSON.stringify(itemData[0])) 
        this.createCustomerServiceQuery(formData).then(async (response) => {
            if (response.success) {
                this.setState({response:response,itemData:itemData[1],itemDataQueryItems:itemData[0]})
                await this.tryImageUpload()
        }
        else {
            this.setState({showErrorInfo: true, isCreating:false,errorMessage: response.statusMessage});
        }
        });
    } catch (error) {
        this.setState({isCreating: false,showErrorInfo: true, errorMessage: `${error} ${error.stack}`});
    }
    };
tryImageUpload = async (retry=false) =>{
    this.setState({isCreating:true,isFailed:false})
    let failedUploadsGeneral = []
    let failedUploadsItems = []
    let itemData = [...this.state.itemData]
    let generalItemData = [...this.state.attachments]
    if (retry) {
        itemData = [...this.state.failedUploadsItems]
        generalItemData = [...this.state.failedUploadsGeneral]
    }
                for (var i = 0; i < generalItemData.length; i++) {
                    this.setState({loaderText:`Uploading General Images - ${i + 1} of ${generalItemData.length}`})
                    const formData = new FormData();
                    formData.append('file', generalItemData[i]);
                    formData.append("client_id",generalItemData[i].upload.uuid)
                    formData.append("token", this.props.token)
                    formData.append("type", "general")
                    let response = await uploadCustomerServiceQueryImages(formData, this.props.token)
                    if (!response.success) {
                        failedUploadsGeneral.push(generalItemData[i])}
                }
                for (var i = 0; i < itemData.length; i++) {
                    this.setState({loaderText:`Uploading Item Images - ${i + 1} of ${itemData.length}`})
                    const formData = new FormData();
                    formData.append('file', itemData[i]);
                    formData.append("client_id",itemData[i].upload.uuid)
                    formData.append("token", this.props.token)
                    formData.append("type", "item")
                    let response = await uploadCustomerServiceQueryImages(formData, this.props.token)
                    if (!response.success) {
                        failedUploadsItems.push(itemData[i])
                    }
                }

                if(failedUploadsGeneral.length > 0 || failedUploadsItems.length > 0){
                    this.setState({isCreating:false,isFailed:true,failedUploadsGeneral:failedUploadsGeneral,failedUploadsItems:failedUploadsItems})
                }else {
                    this.setState({loaderText:"Sending Confirmation Email..."})
                    await this.notifyUserFunction()
                }

    }
    notifyUserFunction = async () => {
        let userData = new FormData();
                userData.append("query_id", this.state.response.query_id)
                userData.append("image_count",this.state.attachments.length + this.state.itemData.length)
                userData.append("query_items", JSON.stringify(this.state.itemDataQueryItems))
                userData.append("token", this.props.token) 
                await notifyUser(userData,this.props.token) 
                this.props.refreshData();
    }
    
    copyErrorToClipboard = () =>{
            navigator.clipboard.writeText(`${this.state.errorMessage} ${JSON.stringify(this.state)}`)
            window.open(`mailto:customer.service@hinchpm.com?subject=Customer%20Service%20Error%20${encodeURIComponent(this.state.reportData.address)}&cc=accounts@hinchpm.com&body=Please%20paste%20error%20CTRL+V`)
            
    }

    createErrorMessage = () =>{
        return <Message  style={{whiteSpace: 'pre-wrap',overflow:"auto",height:"200px"}}align="center" negative
                  onDismiss={() => {
                      this.setState({showErrorInfo: false})
                  }}>
                  <Message.Header>{`Something went wrong. Please try again or contact us through customer.service@hinchpm.com. Quote the following error message which also contains your query so we can recover it:`}
                  <Button onClick={()=>{this.copyErrorToClipboard()}}>Copy Error to Clipboard and open Email</Button></Message.Header>
            
                  {`${this.state.errorMessage} ${JSON.stringify(this.state)}`}
                  </Message>
    }
    createCustomerServiceQuery = async (formData) => {
        return await createCustomerServiceQuery(formData, this.props.token);
    };
    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };
    jumpToItem= (itemNumber) => {
    let jumpLoc =   document.getElementById(`item_${itemNumber < this.state.lastItemIndex? itemNumber : this.state.lastItemIndex}`)
    if(jumpLoc) {
        jumpLoc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    }
    render() {
        const user = this.state.currentUser;
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/*",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                if(file.type.startsWith("image/")){
                    let newAttachments = [...this.state.attachments]
                    newAttachments.push(file)
                    this.setState({imageError:false,attachments:newAttachments})
                }
                else {
                    this.setState({imageError:true})
                }
            },

            removedfile: (file) => {
                this.setState({attachments: this.removingFile(file)});
                if (file.id) {
                    this.deleteQueryImage(file.id).then((res) => {
                    });
                }                        }
        };
        return (
            
                <div>
                    {this.state.isCreating && <Loader contain customText={this.state.loaderText} />}
                    {this.state.isFailed && <Message> <div style={{textAlign:"center"}}>Upload Errors:{this.state.failedUploadsGeneral.length} General Images and {this.state.failedUploadsItems.length} Item Images <br/><Button onClick={() => {this.tryImageUpload(true)}}>Retry Failed Uploads</Button></div></Message>}
            {!this.state.isCreating && !this.state.isFailed &&<Form onSubmit={this.handleSubmit} type="multipart/formdata" style={{ width: '80%', margin: 'auto' }}>
                {this.state.showErrorInfo && <div className="pad-all">{this.createErrorMessage()}</div>}
                <Header content={`Add Customer Service`} size='large' textAlign='center' />
                <Grid centered columns={2} stackable>
                <Grid.Row>
                    <Grid.Column>
                    <Form.Group widths={2}>
                        <Form.Input required label='Querier Name' icon='user' iconPosition='left' placeholder='Querier Name'
                            name="querier_name" />
                        <Form.Input required label='Querier Relation' icon='refresh' iconPosition='left'
                            placeholder='Tenant, Landlord, Agent, etc'
                            type='text' name="querier_relation" />
                        </Form.Group>
                        <Form.Group widths={2}>
                        <Form.Input required label='Querier Email' icon='mail' iconPosition='left'
                            placeholder='abc@xyz.com'
                            type='email' name="validation_email" />
                        {/* <Form.Dropdown required
                            label="Submission Type"
                            selection
                            wrapSelection={false}
                            options={queryTypeOptions}
                            placeholder='Submission Type'
                            defaultValue={"comment"}
                            onChange={(e, option) => {
                            this.setState({queryType: option.value})
                            }}/> */}
                        </Form.Group>
                        <Message negative>
                        <strong>For maintenance issues please refer to the agent as these are not relevant to an inventory report.</strong> The focus of the report is to highlight dilapidations and cleaning issues and will not include maintenance issues such as the following: <ul><strong>
                            <li>Appliances not working</li>
                            <li>Snagging issues</li>
                            <li>External build of property, including windows</li>
                            <li>The keys listed on the inventory report are those received by our clerk for the inventory. If this does not match what you have been given, or additional keys are required, please contact your managing agent/landlord</li>
                        </strong></ul>
                        </Message>
                    </Grid.Column>
                    <Grid.Column>
                        
                        
                        {/* NEW CS SHIT */}
                    <React.Fragment><Header>Select Items To Comment / Query <span style={{float:"right"}}>
                        <Popup header="Download Progress File" trigger={<Button onClick={(e)=>{e.preventDefault(); this.downloadProgress()}}compact icon="download"></Button>}
                            content={<span>Clicking to download a file of your query progress (only text will be saved)</span>}
                        ></Popup>
                    <Popup on="click"
                    trigger={<Button type="button" compact icon="upload" />}
                    content={
                        <div>
                        <span>Select your previously downloaded file below to restore progress.</span>
                        <br />
                        <input  type="file"  accept="application/json" onChange={(e) =>{e.preventDefault();this.importProgress(e)}} style={{ marginTop: '8px' }} />
                        </div>
                    }
                    />

                    {this.state.expanded?<Button onClick={(e)=>{this.toggleExpand(e)}}compact>Hide Notes</Button>:<Button compact onClick={(e)=>{this.toggleExpand(e)}} >Show Notes</Button>}</span></Header><Segment attached="top">

            
                <Input label='Scroll To Item #' style={{width:"80px"}}
                onChange={(e)=>{this.jumpToItem(e.target.value);}}
                    type="number"
                />
                </Segment></React.Fragment>
                    <Segment attached="bottom" style={{height:"350px", overflow:"scroll"}} secondary >
                        {this.state.loading && <Loader contain={true} ></Loader>}
                {this.state.reportData && this.state.reportData.rooms && this.state.reportData.rooms.map((room,roomIndex)=>{
                    
                        return <div key={`room${roomIndex}`}><Segment color="green"><strong>{room.name}</strong></Segment>{room.groups.map((group,groupIndex) =>{return <div key={`group${groupIndex}`}><Segment color="orange"><strong>{group.name}</strong></Segment>{group.items.map((item,itemIndex) =>{ return !item.selected?<div className="csItemTable" key={`item${item.itemIndex}`} >
                           <AddCustomerServiceItem isCo={this.state.reportData["inspection_type"] ==="co"}expanded={this.state.expanded} item={item} itemIndex={itemIndex} roomIndex={roomIndex} groupIndex={groupIndex} toggleList={this.toggleList}></AddCustomerServiceItem>
                                </div>:null})}</div>})}</div>})}
            
                         </Segment>
                    </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Segment secondary>
                            <Header >Selected Items</Header>
                        {this.state.reportData && this.state.reportData.rooms && this.state.reportData.rooms.map((room,roomIndex)=>{
                    
                    return <div key={`selectedRoom${roomIndex}`}>{room.groups.map((group,groupIndex) =>{return <div key={`selectedGroup${groupIndex}`}>{group.items.map((item,itemIndex) =>{return item.selected && <div style={{marginBottom:"15px"}}className="csItemTable" key={`selecteditem${item.itemIndex}`} >
                      <AddCustomerServiceItem addItemImage={this.addItemImage} removeItemImage={this.removeItemImage} updateComment={this.updateComment} isCo={this.state.reportData["inspection_type"] ==="co"} expanded={this.state.expanded} item={item} itemIndex={itemIndex} roomIndex={roomIndex} groupIndex={groupIndex} toggleList={this.toggleList}></AddCustomerServiceItem>
                            </div>})}</div>})}</div>})}</Segment>
                        </Grid.Column>
                    </Grid.Row>
                    
                    
                              {/* ENDNEW CS SHIT */}
                    <Grid.Row>
                    <Grid.Column>
                    <Form.TextArea label='General Query Comment'onChange={(e)=>{this.setState({queryComment:e.target.value})}} value={this.state.queryComment} placeholder='General Query Comment' name="query_comment" style={{ minHeight: 250 }} />
                    <Segment>
                        {this.state.imageError && <Message danger><Message.Header>Attachment error</Message.Header> Only images are supported, this file will not be uploaded</Message>}
                        <Header align="center" as="h4">Only images are accepted</Header>
                        <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                                           eventHandlers={eventHandlers}
                                           djsConfig={djsConfig}/></Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Message negative>
                                <Message.Header>Please relay all your points and images using only one submission.</Message.Header>
                                <p>Do not make individual submissions for each point. All relevant comments should be made in a single query.</p>
                                <p>It is preferred for queries to be submitted through this form. Queries submitted through this form will receive priority in terms of resolution.</p>
                                <p>You can also submit a query through email. To do so please follow the instructions presented on our enquiry template, downloadable at <a href="https://www.hinchpm.com/customer-service"> www.hinchpm.com/customer-service </a>. Queries submitted in this format will be assigned lower priority, therefore it is recommended to submit through the form above</p>
                            </Message>
                            <Message negative>
                                <Message.Header>I ACKNOWLEDGE THAT I WILL NOT BE ABLE TO MAKE MULTIPLE SUBMISSIONS AND THAT ALL INFORMATION IS PRESENT IN THIS SINGLE QUERY</Message.Header>
                                <p>Type <i>ACKNOWLEDGED</i> in the input box below.</p>
                                <Form.Input    onChange={(e) => {this.setState({acknowledgeString:e.target.value})}}></Form.Input>
                            </Message>
                    <div className="submit-buttons">
                        <Button type='submit' primary fluid disabled={this.state.isCreating|| this.state.acknowledgeString != "ACKNOWLEDGED" }>Submit Query</Button>
                    </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                    {this.state.showErrorInfo && <div className="pad-all">{this.createErrorMessage()}</div>}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <div style={{minHeight:'50px'}}></div>
            </Form>}</div>);
    }
}

export default AddCustomerService;


// WEBPACK FOOTER //
// ./src/views/inspection/add_customer_service.js